import { useAtom, useSetAtom } from 'jotai';
import { Box } from '@mui/material';
import { TransformButtonGroup } from './TransformButtonGroup';
import * as state from '../state';
import { useCallback } from 'react';
import { ALLOWED_TRANSFORM_MODES } from '../constants';

export const TopToolbar = () => {
  const [transformMode, setTransformMode] = useAtom(state.transformMode);
  const [isWaitingForRotationCenter, setIsWaitingForRotationCenter] = useAtom(
    state.isWaitingForRotationCenter
  );
  const setRotationCenter = useSetAtom(state.rotationCenter);

  const onSetRotationCenter = useCallback(() => {
    // eslint-disable-next-line no-console
    console.log('setIsWaitingForRotationCenter');
    setIsWaitingForRotationCenter((current) => {
      if (current) {
        setRotationCenter(undefined);
      }
      return !current;
    });
  }, [setIsWaitingForRotationCenter, setRotationCenter]);

  return (
    <Box sx={{ padding: '10px', minHeight: '60px' }}>
      <Box sx={{ display: 'flex', flexDirection: 'row', mr: 10 }}>
        <TransformButtonGroup
          transformMode={transformMode}
          setTransformMode={setTransformMode}
          allowModes={ALLOWED_TRANSFORM_MODES}
          onSetRotationCenter={onSetRotationCenter}
          isWaitingForRotationCenter={isWaitingForRotationCenter}
        />
      </Box>
    </Box>
  );
};
